import type { GlobalImport } from '../shared/interfaces';

import { FormWidgetBase } from './shared/form-widget-base';
import { getAuth0Client, handleRedirectCallback } from './shared/get-auth0-client';

class LogOutWidget extends FormWidgetBase {
    override requiredImports: GlobalImport[] = [`auth0`];

    override async afterConnected() {
        const [auth0Script] = await this.importing;
        if (!auth0Script) {
            this.feedback.innerHTML += `Your browser has failed to load script responsible for authorization.`;
            return;
        }

        const auth0Client = await getAuth0Client(this.publicConfig);

        if (window.location.search.includes(`?code=`)) {
            await handleRedirectCallback(auth0Client);
            window.history.pushState({}, document.title, window.location.pathname);
        }

        const isAuthenticated = await auth0Client.isAuthenticated();
        if (!isAuthenticated) {
            this.feedback.innerHTML += `You need to log in first.`;
            return;
        }

        this.button.disabled = false;
        this.loader.classList.add(`invisible`);
    }

    async submit() {
        const auth0Client = await getAuth0Client();
        await auth0Client.logout();
    }
}

customElements.define(`mh-log-out`, LogOutWidget);

export default LogOutWidget;
